export const ASSIGN_TEAM = 'ASSIGN_TEAM';
export const CLONE = 'CLONE';
export const COMMENT = 'COMMENT';
export const DELETE = 'DELETE';
export const DISABLE = 'DISABLE';
export const EDIT_ACTIONS = 'EDIT_ACTIONS';
export const EDIT_DESCRIPTION = 'EDIT_DESCRIPTION';
export const EDIT_ENROLLMENT = 'EDIT_ENROLLMENT';
export const EDIT_GOAL = 'EDIT_GOAL';
export const EDIT_REENROLLMENT = 'EDIT_REENROLLMENT';
export const EDIT_SETTINGS = 'EDIT_SETTINGS';
export const ENABLE = 'ENABLE';
export const EXPORT = 'EXPORT';
export const MANUAL_ENROLLMENT = 'MANUAL_ENROLLMENT';
export const MOVE = 'MOVE';
export const RESTORE = 'RESTORE';
export const TEST = 'TEST';